import { institution } from "../client";
const config = {
  headers: {},
  signal: null,
};

export const getAllFunctionalities = (params) => {
  const body = {
    flag: "getAllFunctionalities",
    parameters: {
      functionalities: params,
    },
  };
  return institution.post("/get/all/functionalities", body);
};

export const getAllSuperAdminConfigurations = (params) => {
  const body = {
    flag: "getAllSuperAdminConfig",
    parameters: {
      superAdminConfigurations: params,
    },
  };
  return institution.post("/get/super/admin/config", body);
};

export const insertFuncionalities = (params) => {
  const body = {
    flag: "addSuperAdminConfigurations",
    parameters: {
      superAdminConfigurations: params,
    },
  };
  return institution.post("/insert/super/admin/config", body);
};

export const updateFunctionalities = (params) => {
  const body = {
    flag: "updateSuperAdminConfigurations",
    parameters: {
      superAdminConfigurations: params,
    },
  };
  return institution.post("/update/super/admin/config", body);
};

export const geAllInstitutions = (params) => {
  const body = {
    flag: "getAllInstitution",
    parameters: {},
  };
  return institution.post("/get/all/institution", body);
};
